var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckFeedback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check_line_gray",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17452",
    "data-name": "Grupo 17452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_106758",
    "data-name": "Trazado 106758",
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z",
    fill: "#86c000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105414",
    "data-name": "Trazado 105414",
    d: "M23.607,13.231l-1.082-.961a.252.252,0,0,0-.172-.064h0a.241.241,0,0,0-.172.064l-7.5,6.524-2.73-2.357a.265.265,0,0,0-.344,0l-1.095.945a.192.192,0,0,0,0,.3l3.444,2.973a1.166,1.166,0,0,0,.72.3,1.217,1.217,0,0,0,.713-.292h.006l8.222-7.134A.2.2,0,0,0,23.607,13.231Z",
    transform: "translate(-5.105 -4.633)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFeedback);
export default __webpack_public_path__ + "static/media/check_feedback.61d81c1e6ce95be32dbf4abd137ac57d.svg";
export { ForwardRef as ReactComponent };